import React from 'react'
import TableCell from '@mui/material/TableCell'
import VehicleSelect from '../UI/VehicleSelect'
import Checkbox from '@mui/material/Checkbox'

export const EditRowCustomTableCell = ({ row, name, onChange }) => {
  return (
    <>
      {name === 'vehicle' && !row.original_id ? (
        /* NOTE: original_id means a recalculated attack - these have no updateable data */
        <VehicleSelect
          onChange={(e, values) => onChange(e, values, row)}
          value={row[name]}
          width={170}
        />
      ) : name === 'active' ? (
        <Checkbox
          checked={row[name]}
          onChange={e => onChange(e, row)}
          inputProps={{ 'aria-label': 'controlled' }}
        />
      ) : (
        row[name]
      )}
    </>
  )
}

export const CustomTableCell = ({ row, name, onChange }) => {
  const { isEditMode } = row
  return (
    <TableCell align="center">
      {isEditMode ? (
        <EditRowCustomTableCell {...{ row, name, onChange }} />
      ) : name === 'active' ? (
        <Checkbox checked={row[name]} disabled />
      ) : (
        row[name]
      )}
    </TableCell>
  )
}
